/**
 * Created by rxsl-101 on 2018/3/20.
 */
import { MsgBox, Vue } from '../../app.vues';
import { Utils } from '../../app.base';
import { showHtmlToPdfDlg } from '../ctrl/dialog'
//
import retailerApi from '../../api/retailer';

import SwbComStaffSelect from './ComStaffSelect';
import SwbComStaffForSelect from './ComStaffForSelect';
import SwbComStaffMainSelect from './ComStaffMainSelect';
import SwbComStaffImpCheck from './ComStaffImpCheck';
import SwbComImpCheck from './ComImpCheck.vue';
import SwbDownloadCom from './DownloadCom';
import SwbComTreeMultiSelectList from './ComTreeMultiSelect';
import SwbOrgTree from '../orgStruct/OrgTree';

Vue.regist(SwbComStaffSelect);
Vue.regist(SwbComStaffForSelect);
Vue.regist(SwbComStaffMainSelect);
Vue.regist(SwbComStaffImpCheck);
Vue.regist(SwbComImpCheck);
Vue.regist(SwbDownloadCom);
Vue.regist(SwbOrgTree);

export function openComStaffSelectDlg(self, title, data, callback) {
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 700,
        template: '<swb-com-staff-select :checkBox="checkBox" :comId="comId" :bizUnitFlag="bizUnitFlag" :bizUnitId="bizUnitId" :selectedIds="selectedIds" :defMsgReceiverId="defMsgReceiverId" :applyUserFlag="applyUserFlag" :excludeAdmin="excludeAdmin" ref="swb_com_staff_select"></swb-com-staff-select>',
        data: {
            checkBox: data.checkBox,
            applyUserFlag: data.applyUserFlag,  // 仅资产领用人
            bizUnitFlag: data.bizUnitFlag,
            bizUnitId: data.bizUnitId,
            comId: data.id,
            defMsgReceiverId: data.defMsgReceiverId,
            selectedIds: data.staffIds,
            excludeAdmin: data.excludeAdmin // 是否包含admin
        },
        okClicked: function () {
            let result = this.$refs.swb_com_staff_select.getDlgResult() || {};
            if(data.comnFlag != null && data.comnFlag) {
                if(result.type == 'info') {
                    callback(result.data, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            } else {
                retailerApi.doSpecifyRetailerComReceiver(result, function (result) {
                    if(result.type == 'info') {
                        self.$message.success('操作成功');
                        callback();
                        theDlg.close();
                    } else {
                        self.$message.error('操作失败');
                    }
                });
            }
            return false;
        },
        methods: {}
    });
}

// 选人组件
export function openComStaffComnSelectDlg(comId, bizUnitFlag, callback, roleId) {
    //
    let theDlg = Vue.$showDialog({
        title: '人员选择',
        width: 900,
        height: 700,
        template: '<swb-com-staff-select :comId="comId" :roleId="roleId" :bizUnitFlag="bizUnitFlag" ref="swb_com_staff_select"></swb-com-staff-select>',
        data: {
            comId: comId,
            bizUnitFlag: bizUnitFlag,
            roleId: roleId
        },
        okClicked: function () {
            let result = this.$refs.swb_com_staff_select.getDlgResult() || {};
            callback(result, theDlg);
            //
            return false;
        },
        methods: {}
    });
}

// 当前公司及下级公司的员工列表
export function openThisOrDownComStaffForSelectDlg(eventMsgId, callback) {
    let self = this;
    Vue.$showDialog({
        title: '公司的员工列表',
        height: '70%',
        showCloseBtn: true,
        template: '<swb-com-staff-for-select :eventMsgId="eventMsgId" ref="swb_com_staff_for_select"></swb-com-staff-for-select>',
        data: {
            eventMsgId: eventMsgId
        },
        okClicked: function () {
            let result = this.$refs.swb_com_staff_for_select.getDlgResult() || {};
            if(result.type === 'info') {
                callback(result.data);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

// 当前公司及下级公司的员工列表 左侧组织架构树-右侧人员列表
export function openComStaffMainForSelectDlg(dlgConfig = {}, callback) {
    //
    let defComId = dlgConfig['defComId'] || null; // 默认显示的公司人员
    let isCom = dlgConfig['isCom'] || null; // 是否获取全部的公司
    let isCurrentCom = dlgConfig['isCurrentCom'] || null; // 是否获取全部的公司
    let isSelectThisLevel = dlgConfig['isSelectThisLevel'] || null; // 本级是否可选
    let title = dlgConfig['title'] || '公司的员工列表'; // 本级是否可选
    let checkBox = Utils.isTrue(dlgConfig['checkBox']);
    let selectedIds = dlgConfig['selectedIds'] || [];
    let bizUnitIds = dlgConfig['bizUnitIds'] || null; // 显示当前单元下的人员
    let bizUnitId = dlgConfig['bizUnitId'] || null; // 显示当前单元下的人员
    let roleIds = dlgConfig['roleIds'] || null; // 指定岗位相关的人员
    //
    let theDlg = Vue.$showDialog({
        title: title,
        height: 800,
        width: 1300,
        showCloseBtn: true,
        template: '<swb-com-staff-main-select :roleIds="roleIds" :bizUnitIds="bizUnitIds" :bizUnitId="bizUnitId" :isCurrentCom="isCurrentCom" :defComId="defComId" :hidden="true"  :isCom="isCom" :isSelectThisLevel="isSelectThisLevel" :checkBox="checkBox" :selectedIds="selectedIds" ref="swb_com_staff_main_select"></swb-com-staff-main-select>',
        data: {
            defComId: defComId,
            isCom: isCom,
            isSelectThisLevel: isSelectThisLevel,
            isCurrentCom: isCurrentCom,
            checkBox: checkBox,
            selectedIds: selectedIds,
            bizUnitIds: bizUnitIds,
            bizUnitId: bizUnitId,
            roleIds: roleIds,
        },
        okClicked: function () {
            let result = this.$refs.swb_com_staff_main_select.getDlgResult() || {};
            if(result.type === 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

// 公司员工批量导入
export function openComStaffImpCheckDlg(comName, comId, callback) {
    let theDlg = Vue.$showDialog({
        title: '公司员工批量导入',
        width: 1200,
        height: 700,
        showCloseBtn: true,
        okText: '导入',
        template: '<swb-com-staff-imp-check :comName="comName":comId="comId" ref="swb_com_staff_imp_check"></swb-com-staff-imp-check>',
        data: {
            comName: comName,
            comId: comId
        },
        okClicked: function () {
            let result = this.$refs.swb_com_staff_imp_check.getDlgResult() || {};
            if(result.type === 'info') {
                let comStaffImpInfoList = result.data;
                //
                callback(comStaffImpInfoList, theDlg);
            } else {
                Toast.show(result.message);
            }
            return false;
        }
    });
}

//机构导入检查
export function openComImpCheckDlg(bizDepartFlag, bizUnitType, comId, comName, callback) {
    let title = '机构';
    // let bizUnitTypeX = getEnumInfoWith('bizUnitType', 'value', bizUnitType);
    if(bizDepartFlag) {
        title = '部门';
    }
    let theDlg = Vue.$showDialog({
        title: '批量导入 -- ' + title,
        width: 1100,
        height: 750,
        showCloseBtn: true,
        template: '<swb-com-imp-check :bizDepartFlag="bizDepartFlag" :bizUnitType="bizUnitType" ref="swb_com_imp_check"></swb-com-imp-check>',
        data: {
            bizDepartFlag: bizDepartFlag,
            bizUnitType: bizUnitType
        },
        methods: {
            saveRetailerComBatch: function (checkFlag, sameCostPrft, comImpInfoList) {
                let warnMsg = '';
                if(checkFlag) {
                    warnMsg = '：您导入的数据已在系统中存在，请您再次确认是否继续导入数据吗？';
                }
                if(sameCostPrft) {
                    warnMsg = '：您本次导入的数据存在成本中心编码与利润中心编码不一致情况，请您再次确认是否继续导入该数据？';
                }
                if(checkFlag && sameCostPrft) {
                    warnMsg = '：您导入的数据已在系统中存在并且存在成本中心编码与利润中心编码不一致情况，请您再次确认是否继续导入数据吗？';
                }
                this.$confirm('确定对【' + comName + '】导入' + title + warnMsg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoading = MsgBox.loading();
                    let postData = {};
                    postData.id = comId;
                    postData.comSons = comImpInfoList;
                    retailerApi.saveRetailerComBatch(postData, function (result) {
                        theLoading.close();
                        if(result.type == 'info') {
                            callback(result.data);
                            theDlg.close();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_com_imp_check.getDlgResult() || {};
            //
            if(result.type == 'info') {
                let comImpInfoList = result.data || [];
                let checkFlag = false;
                let sameCostPrft = false;
                for(let i = 0; i < comImpInfoList.length; i++) {
                    let comImpInfo = comImpInfoList[i];
                    if(!Utils.isNoB(comImpInfo.costCenterCode) && !Utils.isNoB(comImpInfo.prftCenterCode) && comImpInfo.costCenterCode != comImpInfo.prftCenterCode) {
                        sameCostPrft = true;
                    }
                    //
                    if(!Utils.isNoB(comImpInfo.name) && !Utils.isNoB(comImpInfo.costCenterCode) && !Utils.isNoB(comImpInfo.realComCode) && comImpInfo.orgType == 1) {
                        let postData = {
                            name: comImpInfo.name,
                            costCenterCode: comImpInfo.costCenterCode,
                            realComCode: comImpInfo.realComCode
                        };
                        let theLoad = MsgBox.loading();
                        retailerApi.getRetailerComCountByCostPrft(postData, function (resultData) {
                            theLoad.hide();
                            if(resultData.type == 'info') {
                                if(!Utils.isNoB(resultData.data) && resultData.data > 0) {
                                    checkFlag = true;
                                }
                            } else {
                                self.$message.error(result.message);
                            }
                        });
                    }
                }
                self.saveRetailerComBatch(checkFlag, sameCostPrft, comImpInfoList);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
    });
}

Vue.regist(SwbComTreeMultiSelectList);

//TODO displayDataList [{comId,comId1,comId2,comId3}] 回显必传
export function openRetailerComTreeMultiSelectDlg(dlgConfig = {}, displayDataList = [], callback) {
    if(Utils.isNoB(callback)) {
        MsgBox.warning('回调函数不可为空');
        return;
    }
    if(typeof callback != 'function') {
        MsgBox.warning('callback 不是回调函数，请确认');
        return;
    }
    //
    let noPostFilters = dlgConfig['noPostFilters'] || false;
    let showCheckboxLevel1 = dlgConfig['showCheckboxLevel1'] || false;
    let showCheckboxLevel2 = dlgConfig['showCheckboxLevel2'] || false;
    let showCheckboxLevel3 = dlgConfig['showCheckboxLevel3'] || false;
    let checkStrictly = dlgConfig['checkStrictly'] || false;
    let model = dlgConfig['model'] || null;
    if(model == null) {
        model = {};
        model.comIdColumn = 'comId'; //
        model.comNameColumn = 'comName';
        model.comBizUnitNameColumn = 'bizUnitName';
        model.comLevelColumn = 'comLevel';
        model.comBizFormIdColumn = 'bizFormId';
        model.comBizAreaIdColumn = 'bizAreaId';
    }
    let bizDepart = dlgConfig['bizDepart'] || false;
    let bizUnitId = dlgConfig['bizUnitId'] || null;
    let usableRealComIds = dlgConfig['usableRealComIds'];
    let defaultCheckedItems = displayDataList || [];
    let optionalState = dlgConfig['optionalState'] || [1, 3];
    let defalultState = dlgConfig['defalultState'] || [1, 3];
    //
    Vue.$showDialog({
        title: '零售商机构 - 选择',
        width: 800,
        height: 700,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
            '<swb-retailer-com-tree-multi-select :optionalState="optionalState" :defalultState="defalultState" :bizDepart = "bizDepart" :bizUnitId = "bizUnitId" :noPostFilters = "noPostFilters" :showCheckboxLevel1="showCheckboxLevel1" :showCheckboxLevel2 = "showCheckboxLevel2" :showCheckboxLevel3="showCheckboxLevel3" :checkStrictly = "checkStrictly" :defaultCheckedItems = "defaultCheckedItems" :model = "model" :usableRealComIds="usableRealComIds" ref="swb_retailer_com_tree_multi_select"></swb-retailer-com-tree-multi-select>' +
            '</div>',
        data: {
            noPostFilters: noPostFilters,
            showCheckboxLevel1: showCheckboxLevel1,
            showCheckboxLevel2: showCheckboxLevel2,
            showCheckboxLevel3: showCheckboxLevel3,
            checkStrictly: checkStrictly,
            defaultCheckedItems: defaultCheckedItems,
            model: model,
            bizDepart: bizDepart,
            bizUnitId: bizUnitId,
            usableRealComIds: usableRealComIds,
            optionalState: optionalState,
            defalultState: defalultState
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_retailer_com_tree_multi_select.getDlgResult() || {};
            //
            console.log('选择机构信息：', result);

            callback(result);
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

export function openDownloadComDlg(callBack) {
    let theDlg = Vue.$showDialog({
        title: '导出机构',
        width: 600,
        height: 400,
        showCloseBtn: true,
        template: '<swb-com-download ref="swb_com_download"></swb-com-download>',
        data: {},
        okClicked: function () {
            let result = this.$refs.swb_com_download.getDlgResult() || {};
            if(result.type === 'info') {
                theDlg.close();
                let resultData = result.data;
                callBack(resultData)
            } else {
                Toast.show(result.message);
            }
            return false;
        }
    });
}

export function openBizUnitOrgTreeDlg(dlgConfig = {}, callBack) {
    let enableSearch = dlgConfig['enableSearch'] || false; // 搜索
    let isRadio = dlgConfig['isRadio'] || false;
    let accordion = dlgConfig['accordion'] || false;
    let dblclickFlag = dlgConfig['dblclickFlag'] || false;
    let closedComSelect = dlgConfig['closedComSelect'] || false;
    let bizUnitId = dlgConfig['bizUnitId'] || null;
    let isCom = dlgConfig['isCom'] || false;
    let title = dlgConfig['title'] != null ? dlgConfig['title'] : '业务单元';
    let bizDepart = dlgConfig['bizDepart'] || false;
    let isSelectThisLevel = dlgConfig['isSelectThisLevel'] || false;
    let usableRealComIds = dlgConfig['usableRealComIds'];
    let optionalState = dlgConfig['optionalState'] || [1, 3];
    let defalultState = dlgConfig['defalultState'] || [1, 3];
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 750,
        height: 800,
        showCloseBtn: true,
        template: '<swb-org-tree :isCom="isCom" :bizDepart = "false" :enableSearch="enableSearch" :isRadio="isRadio" :accordion="accordion" :dblclickFlag="dblclickFlag" :optionalState="optionalState" :defalultState="defalultState" :closedComSelect="closedComSelect" :bizDepart="bizDepart" :bizUnitId="bizUnitId" :isSelectThisLevel = "isSelectThisLevel" :usableRealComIds="usableRealComIds" ref="swb_biz_unit_org_tree"></swb-org-tree>',
        data: {
            enableSearch: enableSearch,
            isRadio: isRadio,
            accordion: accordion,
            dblclickFlag: dblclickFlag,
            closedComSelect: closedComSelect,
            bizUnitId: bizUnitId,
            bizDepart: bizDepart,
            isCom: isCom,
            isSelectThisLevel: isSelectThisLevel,
            usableRealComIds: usableRealComIds,
            optionalState: optionalState,
            defalultState: defalultState
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_biz_unit_org_tree.getDlgResult() || {};
            //
            if(result.type == 'info') {
                callBack(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

export function openBizDepartDlg(comId, callback, title, isSelectThisLevel) {
    let titleName = title != null ? title : '责任部门 - 选择';
    Vue.$showDialog({
        title: titleName,
        width: 750,
        height: 600,
        showCloseBtn: true,
        template: '<swb-org-tree :bizDepart="true" :merchantId="merchantId" :bizUnitId="bizUnitId" :isRadio="true" :isSelectThisLevel="isSelectThisLevel" ref="swb_org_tree"></swb-org-tree>',
        data: {
            bizUnitId: null,
            merchantId: null,
            isSelectThisLevel: isSelectThisLevel,
        },
        okClicked: function () {
            let result = this.$refs.swb_org_tree.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data);
                return true;
            } else {
                MsgBox.warning(result.message);
            }
        },
        lifecycle: {
            created: function () {
                let self = this;
                retailerApi.getRetailerCom({comId: comId}, function (result) {
                    self.bizUnitId = result.data.bizUnitId;
                    self.merchantId = result.data.merchantId;
                });
            }
        }
    });
}

import SwbRealComTree from './RealComTree'

Vue.regist(SwbRealComTree);

export function openRealComTreeDlg(dlgConfig = {}, callBack) {
    let multiSelect = Utils.isTrue(dlgConfig['multiSelect']); // 实体公司是否多选
    let isRadio = Utils.isTrue(dlgConfig['isRadio']); // 实体公司是否展示单选框
    let selectRealComId = dlgConfig['selectRealComId'] || null; // 当前实体公司Id
    let realComDefFirst = dlgConfig['realComDefFirst'] == null ? true : Utils.isTrue(dlgConfig['realComDefFirst']); // 公司树是否默认第一个
    let enableSearch = dlgConfig['enableSearch'] == null ? true : Utils.isTrue(dlgConfig['enableSearch']); // 可搜索
    let accordion = Utils.isTrue(dlgConfig['accordion']); // 是否手风琴模式
    let dblclickFlag = Utils.isTrue(dlgConfig['dblclickFlag']); // 是否双击事件
    let costFlag = Utils.isTrue(dlgConfig['costFlag']); // 是否获取成本中心
    let prftFlag = dlgConfig['prftFlag'] == null ? true : Utils.isTrue(dlgConfig['prftFlag']); // 是否获取利润中心
    let deprFlag = Utils.isTrue(dlgConfig['deprFlag']); // 折旧使用，查询实体公司的累计折旧金额
    //
    let theDlg = Vue.$showDialog({
        title: '实体公司 - 选择',
        width: 750,
        height: 800,
        showCloseBtn: true,
        template: '<swb-real-com-tree ref="realComTree" :multiSelect="multiSelect" :isRadio="isRadio" :selectRealComId="selectRealComId" :realComDefFirst="realComDefFirst" ' +
            ':enableSearch="enableSearch" :accordion="accordion" :dblclickFlag="dblclickFlag" :costFlag="costFlag" :prftFlag="prftFlag" :deprFlag="deprFlag"></swb-real-com-tree>',
        data: {
            multiSelect: multiSelect,
            isRadio: isRadio,
            selectRealComId: selectRealComId,
            realComDefFirst: realComDefFirst,
            enableSearch: enableSearch,
            accordion: accordion,
            dblclickFlag: dblclickFlag,
            costFlag: costFlag,
            prftFlag: prftFlag,
            deprFlag: deprFlag
        },
        okClicked: function () {
            let result = this.$refs.realComTree.getDlgResult() || {};
            //
            if(result.type == 'info') {
                callBack(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbCheckComStateList from './checkComStateList'

Vue.regist(SwbCheckComStateList);

export function openCheckComStateListDlg(dlgConfig = {}) {
    let comList = dlgConfig['comList'] || [];
    Vue.$showDialog({
        title: '下级机构状态检查结果',
        width: 600,
        height: 800,
        okText: '下载未通过明细',
        cancelText: '关闭',
        showCloseBtn: true,
        template: '<swb-check-com-state-list :comList="comList" ref="swb_check_com_state_list" ></swb-check-com-state-list>',
        data: {
            comList: comList
        },
        okClicked: function () {
            let result = this.$refs.swb_check_com_state_list.checkComStateList() || {}
            showHtmlToPdfDlg('未通过明细', result, null);
            return false;
        }
    });
}

import SwbOrgStateChangCheckDlg from './OrgStateChangCheckDlg';

Vue.regist(SwbOrgStateChangCheckDlg)

export function openOrgStateChangCheckDlg(title, checkList) {
    let okVisible = true;
    let okText = '下载未通过明细';
    let cancelVisible = true;
    let cancelText = '关闭';
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: -100,
        height: -100,
        okVisible: okVisible,
        okText: okText,
        cancelVisible: cancelVisible,
        cancelText: cancelText,
        template: '<div>' +
            '<swb-org-state-change-check-dlg :checkList="checkList" ref="swb_org_state_change_check_dlg"></swb-org-state-change-check-dlg>' +
            '</div>',
        data: {
            checkList: checkList
        },
        okClicked: function () {
            let result = this.$refs.swb_org_state_change_check_dlg.getDlgResult() || {}
            showHtmlToPdfDlg(title + '未通过明细', result, null);
            return false;
        },
        methods: {}
    })
}

import SwbComDetail from './ComDetail';

Vue.regist(SwbComDetail)

export function openComDetailDlg(comId, title) {
    title = title || '机构详情';
    Vue.$showDialog({
        title: title,
        width: 800,
        height: 800,
        okVisible: false,
        cancelText: '关闭',
        showCloseBtn: true,
        template: '<swb-com-detail :comId="comId" ref="swb_check_com_state_list" ></swb-com-detail>',
        data: {
            comId: comId
        }
    });
}

import SwbRealComInfo from './RealComInfo';

Vue.regist(SwbRealComInfo)

export function openRealComInfoDlg(id) {
    Vue.$showDialog({
        title: '公司详情',
        width: 800,
        height: 800,
        okVisible: false,
        cancelText: '关闭',
        showCloseBtn: true,
        template: '<swb-real-com-info :id="id" ref="swb_real_com_info" ></swb-real-com-info>',
        data: {
            id: id
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/orgStruct/selectDlg.js
// module id = 18
// module chunks = 0